import { Store } from "redux";
import { SeoRenderer } from "../../../common/helpers/seo";
import { IStateTree } from "../../store/interfaces";
import { getTeacher } from "../../store/teacher/actions";

import Teacher from "./loadable";

export default {
    component: Teacher,
    loadData: ({ dispatch }: { dispatch: any }, path: string) => dispatch(getTeacher(path)),
    renderSeo: ({ getState }: Store<IStateTree>, allMessage: {[key: string]: string}, lang: string) => {
        const { teacher } = getState();
        if (teacher!.notFound) {
            SeoRenderer({ title: allMessage["teacher.teacherNotFound"], allMessage, lang });
        }
        SeoRenderer({ title: teacher!.displayName || teacher!.username, type: "profile", allMessage, lang });
    },
};
